import { OrderType } from 'enums';
import { CashbackPage } from 'features/cashback';

export const AdminPayinCashbackPage: React.FC = () => (
  <CashbackPage orderType={OrderType.Payin} />
);
